import Swiper from 'swiper/bundle';

export function idxFunc() {
  const swiperSlides = document.getElementsByClassName('swiper-container');
  const breakPoint = 768;
  let flowSwiper;
  let flowSwiperBool;


  window.addEventListener('load', () => {
    if (breakPoint < window.innerWidth) {
      flowSwiperBool = false;
    } else {
      createSwiper();
      flowSwiperBool = true;
    }
  }, false);

  window.addEventListener('resize', () => {
    if (breakPoint < window.innerWidth && flowSwiperBool) {
      flowSwiper.destroy(false, true);
      flowSwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !(flowSwiperBool)) {
      createSwiper();
      flowSwiperBool = true;
    }
  }, false);

  const createSwiper = () => {
    flowSwiper = new Swiper('.swiper-container', {
      // autoplay: {
      //   delay: 5000
      // },
      speed: 500,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }
}